var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { useCurrentBackground } from '../useCurrentBackground';
import { LayoutContext } from './Layout.context';
import { LayoutChild, } from './Layout.interface';
import { LayoutTransparentContainer, LayoutColoredContainer, } from './Layout.style';
export var Layout = React.forwardRef(function (props, ref) {
    var _a, _b, _c, _d;
    var defaultBackground = useCurrentBackground();
    var children = props.children, _e = props.backgroundColor, backgroundColor = _e === void 0 ? defaultBackground : _e, rest = __rest(props, ["children", "backgroundColor"]);
    var _f = React.useState({}), registeredChildren = _f[0], setRegisteredChildren = _f[1];
    var context = React.useMemo(function () { return ({
        isInLayout: true,
        registerChild: function (type) {
            var id = Math.random();
            setRegisteredChildren(function (prev) {
                var _a;
                var _b;
                return (__assign(__assign({}, prev), (_a = {}, _a[type] = __spreadArray(__spreadArray([], ((_b = prev[type]) !== null && _b !== void 0 ? _b : []), true), [id], false), _a)));
            });
            return function () {
                return setRegisteredChildren(function (prev) {
                    var _a;
                    var _b;
                    return (__assign(__assign({}, prev), (_a = {}, _a[type] = ((_b = prev[type]) !== null && _b !== void 0 ? _b : []).filter(function (el) { return el !== id; }), _a)));
                });
            };
        },
    }); }, []);
    var hasActionBar = ((_b = (_a = registeredChildren[LayoutChild.ActionBar]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    var hasHeaderBar = ((_d = (_c = registeredChildren[LayoutChild.HeaderBar]) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
    return (React.createElement(LayoutContext.Provider, { value: context }, backgroundColor ? (React.createElement(LayoutColoredContainer, __assign({ ref: ref }, rest, { backgroundColor: backgroundColor, "data-has-action-bar": hasActionBar, "data-has-header-bar": hasHeaderBar }), children)) : (React.createElement(LayoutTransparentContainer, __assign({ ref: ref }, rest, { "data-has-action-bar": hasActionBar, "data-has-header-bar": hasHeaderBar }), children))));
});
//# sourceMappingURL=Layout.js.map